var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "provider-instructions-component",
      class: { terminal: _vm.terminal },
    },
    [
      _c(
        "div",
        {
          staticClass: "instructions-container",
          class: {
            "px-4": _vm.terminal,
            "pt-3": _vm.terminal,
            "pb-4": _vm.terminal,
            "font-monospace": _vm.terminal,
            "elevation-10": _vm.terminal,
            "close-animation": _vm.closeAnimation,
          },
        },
        [
          _vm.terminal
            ? _c(
                "div",
                { staticClass: "useless-rounds pb-3" },
                _vm._l(3, function (n) {
                  return _c("div", {
                    key: n,
                    staticClass: "useless-round",
                    on: {
                      click: function ($event) {
                        n === 1 && _vm.onClose()
                      },
                    },
                  })
                }),
                0
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.provider === "baremetal"
            ? _c(
                "div",
                [
                  _c("p", [
                    _vm._v(
                      "\n          1- Install PM2 Runtime on your server:\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "CodeExtract",
                    {
                      attrs: {
                        prompt: "$",
                        checked: _vm.serverLinked || _vm.appLinked,
                      },
                    },
                    [_vm._v("\n          npm install -g pm2\n        ")]
                  ),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v("\n          2- Then link PM2 to PM2.io:\n        "),
                  ]),
                  _vm._v(" "),
                  _c(
                    "CodeExtract",
                    { attrs: { prompt: "$", checked: _vm.serverLinked } },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.onPremiseEnv) +
                          _vm._s(_vm.localPremiseDevEnv) +
                          "pm2 link " +
                          _vm._s(_vm.secretId) +
                          " " +
                          _vm._s(_vm.publicId) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "\n          3- You're set. Now start a Node.js application:\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "CodeExtract",
                    { attrs: { prompt: "$", checked: _vm.appLinked } },
                    [_vm._v("\n          pm2 start app.js\n        ")]
                  ),
                ],
                1
              )
            : _vm.provider === "docker"
            ? _c(
                "div",
                [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("CodeExtract", [
                    _vm._v(
                      "\nRUN npm install pm2 -g\nENV PM2_PUBLIC_KEY " +
                        _vm._s(_vm.publicId) +
                        "\nENV PM2_SECRET_KEY " +
                        _vm._s(_vm.secretId) +
                        "\n" +
                        _vm._s(_vm.onPremiseConfigDocker) +
                        '\nCMD ["pm2-runtime", "app.js"]\n        '
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "\n          Finally, start the container.\n        "
                    ),
                  ]),
                ],
                1
              )
            : _vm.provider === "ebs"
            ? _c(
                "div",
                [
                  _c("p", [
                    _vm._v(
                      "\n          First, add pm2 as a dependency:\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("CodeExtract", { attrs: { prompt: "$" } }, [
                    _vm._v("\n          npm install pm2\n        "),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v("\n          Edit your package.json:\n        "),
                  ]),
                  _vm._v(" "),
                  _c("CodeExtract", [
                    _vm._v(
                      '\n"scripts": {\n  "prod:start": "pm2-runtime app.js"\n}\n        '
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v("\n          Set the env variables:\n        "),
                  ]),
                  _vm._v(" "),
                  _c("CodeExtract", { attrs: { prompt: "$" } }, [
                    _vm._v(
                      "\nPM2_PUBLIC_KEY=" +
                        _vm._s(_vm.publicId) +
                        "\nPM2_SECRET_KEY=" +
                        _vm._s(_vm.secretId) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "\n          Finally, deploy your application.\n        "
                    ),
                  ]),
                ],
                1
              )
            : _vm.provider === "heroku"
            ? _c(
                "div",
                [
                  _c("p", [
                    _vm._v(
                      "\n          First, add pm2 as a dependency:\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("CodeExtract", { attrs: { prompt: "$" } }, [
                    _vm._v("\n          npm install pm2\n        "),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v("\n          Edit your package.json:\n        "),
                  ]),
                  _vm._v(" "),
                  _c("CodeExtract", [
                    _vm._v(
                      '\n"scripts": {\n  "start": "pm2-runtime app.js"\n}\n        '
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v("\n          Set the env variables:\n        "),
                  ]),
                  _vm._v(" "),
                  _c("CodeExtract", { attrs: { prompt: "$" } }, [
                    _vm._v(
                      "\n          heroku config:set " +
                        _vm._s(_vm.onPremiseEnv) +
                        _vm._s(_vm.localPremiseDevEnv) +
                        "PM2_PUBLIC_KEY=" +
                        _vm._s(_vm.publicId) +
                        " PM2_SECRET_KEY=" +
                        _vm._s(_vm.secretId) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "\n          Finally, deploy your application.\n        "
                    ),
                  ]),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _vm.terminal
        ? _c("div", { staticClass: "egg-message" }, [
            _vm._v("\n      Oh hi, Mark!\n    "),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("\n          Edit your Dockerfile and replace the "),
      _c("code", { staticClass: "base px-1" }, [_vm._v("node")]),
      _vm._v(" by\n          "),
      _c("code", { staticClass: "base px-1" }, [_vm._v("pm2-runtime")]),
      _vm._v(":\n        "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }